import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import DatePickerContext from "nlib/ui/DatePicker/lib/DatePickerContext";
import React, { useContext } from "react";
import classNames from "classnames";

const DatePickerContainer = ({ monthOnly, className, children }) => {
  const { showCloseButton, onClose } = useContext(DatePickerContext);

  return (
    <div className={classNames(Css.datePickerContainer, monthOnly && Css.monthOnly, className)}>
      <div className={Css.header}>
        {showCloseButton && (
          <div className={Css.close} onClick={onClose}>
            <Icons.X weight="bold" />
          </div>
        )}
      </div>
      <div className={Css.content}>
        {children}
      </div>
    </div>
  );
};

export default React.memo(DatePickerContainer);
